import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a2445d98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container shadow-2 p-4 fixed top-0 left-0 right-0 z-2" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  href: "/",
  class: "no-underline text-900 ml-2"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "white-space-nowrap overflow-hidden text-overflow-ellipsis hidden sm:inline w-5 md:w-auto" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "pi pi-user"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-5rem" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_LoginButton = _resolveComponent("LoginButton")!
  const _component_LogoutButton = _resolveComponent("LogoutButton")!
  const _component_Toolbar = _resolveComponent("Toolbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          (_ctx.appLogo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.appLogo,
                alt: _ctx.appName
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("a", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.appName), 1)
          ])
        ]),
        end: _withCtx(() => [
          (_ctx.webId)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.webId,
                class: "no-tap-highlight no-underline text-900 gap-2 flex align-items-center justify-content-end"
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.name), 1),
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_Avatar, {
                      key: 0,
                      shape: "circle",
                      class: "border-1"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.img)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.img
                            }, null, 8, _hoisted_6))
                          : (_openBlock(), _createElementBlock("i", _hoisted_7))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_4))
            : _createCommentVNode("", true),
          (!_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_LoginButton, { key: 1 }))
            : (_openBlock(), _createBlock(_component_LogoutButton, { key: 2 }))
        ]),
        _: 1
      })
    ]),
    _hoisted_8
  ], 64))
}